import { Linking } from 'react-native'

export class LinkingAdapter {
  openURL: Linking['openURL']
  canOpenURL: Linking['canOpenURL']

  constructor(methods: Pick<Linking, 'openURL' | 'canOpenURL'>) {
    this.openURL = methods.openURL.bind(Linking)
    this.canOpenURL = methods.canOpenURL.bind(Linking)
  }
}
